module.exports = __webpack_public_path__ + "static/media/landing-homesafe.00610098.png";